export enum NoticePlacement {
  SALE_ADD_PRODUCT_IDENTIFIER_SN = 1,
  WARRANTY_ACTIVATION_IDENTIFIER_SN = 2,
  DIGITAL_PASSPORT_HEADER = 3,
  DIGITAL_PASSPORT_FOOTER = 4
}
